import { useState } from 'react';
import { createChatbotReview } from '../services/ai.service';

const useChatbotFeedbackSubmit = (chatbotId: number | null) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitFeedback = async (rating: number, comment: string) => {
    if (!chatbotId) {
      setError('ID de chatbot manquant');
      return false;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      await createChatbotReview(chatbotId, rating, comment);
      return true;
    } catch (err: any) {
      const errorMessage =
        err?.response?.data?.error?.message ||
        err?.message ||
        "Une erreur est survenue lors de l'envoi de votre avis";
      setError(errorMessage);
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  const reset = () => {
    setError(null);
    setIsSubmitting(false);
  };

  return { submitFeedback, isSubmitting, error, reset };
};

export default useChatbotFeedbackSubmit;
